import { useContext, useEffect } from 'react';
import { FooterHelp, Layout, Link, Page, Text } from '@shopify/polaris';
import { TitleBar, useAppBridge } from '@shopify/app-bridge-react';
import { getSessionToken } from "@shopify/app-bridge/utilities";
import { useShopifyAuth } from './hooks/useShopifyAuth';
import Firebase, { FirebaseContext } from './contexts/firebase';
import { AppConfigProvider } from './contexts/AppConfigContext/AppConfigProvider';
import { LoadingSpinner } from './components/Loading/LoadingSpinner';
import { AuthError } from './components/Errors/AuthError';
import { ImplementationInstructions } from './components/ImplementationInstructions';
import { Configuration } from './components/Configuration';

export const App = ({ shop }: { shop: string }) => {
  const app = useAppBridge();
  const firebase = useContext(FirebaseContext) as Firebase;

  // get data
  const { initialized, isError, handleAuthorize } = useShopifyAuth(
    firebase,
    app, 
    shop,
    getSessionToken,
  );

  useEffect(() => {
    handleAuthorize();
  }, [handleAuthorize]);

  const loadingContent = <LoadingSpinner text="Loading" />;
  const errorContent = <AuthError />;
  const markupContent = (
    <>
      <Layout>
        <Configuration
          app={app}
          firebase={firebase}
          />

        <ImplementationInstructions
          app={app}
          firebase={firebase}
          />
      </Layout>
      <FooterHelp>
        <Text variant="bodyMd" as="span" color="subdued">
          App developed for Trimtex | Developed by{' '}
          <Link url="https://code.nl/" external>
            CODE - Your Shopify Plus Partner
          </Link>
        </Text>
      </FooterHelp>
    </>);

  return (
    <AppConfigProvider firebase={firebase} app={app}>
      <Page fullWidth>
        <TitleBar
          title="Configuration & settings"
        />
        {
          !initialized ? 
            loadingContent : 
            (isError ? 
              errorContent : 
              markupContent
            )
        }
      </Page>
    </AppConfigProvider>
  );

}

